export default __webpack_public_path__ + "static/media/logo3.ba6f10c5.svg";